import NavBar from "../../NavBar";
import Footer from "../../Footer";

import { useForm } from "react-hook-form";
import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { deleteAccount } from "../../services/Services";

export default function DeleteAccount() {
  const [error, setError] = useState(false);
  const [message, setMessage] = useState();
  const [result, setResult] = useState();

  const formSchema = Yup.object().shape({
    email: Yup.string()
      .required("Email is required")
      .email("Must be a valid email"),
    password: Yup.string()
      .required("Password is required")
      .min(6, "Password must be at 6 char long"),
  });

  const formOptions = { resolver: yupResolver(formSchema) };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm(formOptions);

  const onSubmit = (data, e) => {
    e.preventDefault();
    deleteAccount(data)
      .then((res) => {
        if (res.status) {
          setResult(res.status);
        } else if (res.error) {
          setMessage(res.error);
          setError(true);
        }
      })
      .catch((err) => {
        setMessage(err.message);
        setError(true);
      });
  };

  return (
    <>
      <NavBar />
      <section className="bg-light">
        <div className="col-lg-6 mx-auto">
          <h4 className="fw-bold text-body-emphasis mb-5">DELETE ACCOUNT</h4>
          <p className="pb-3">
            Please provide your account credentials to delete account.
          </p>
        </div>
        <div className="gap-2 d-sm-flex justify-content-center div-login-info">
          <div className="col-xs-10 col-sm-10 col-md-8 col-lg-6 col-xl-4">
            <form
              className="form-floating px-3"
              onSubmit={handleSubmit(onSubmit)}
            >
              {/*  email address */}
              <div className={"form-floating " + (errors.email ? "" : "mb-3")}>
                <input
                  type="email"
                  id="email"
                  placeholder="email"
                  className={
                    "form-control " + (errors.email ? "is-invalid" : "")
                  }
                  {...register("email")}
                />
                <label htmlFor="email">Email:</label>
              </div>
              {errors.email?.message && (
                <div className="row align-items-start text-start mb-3">
                  <span className="span-errors" role="alert">
                    {errors.email.message}
                  </span>
                </div>
              )}
              {/*  password  */}
              <div
                className={"form-floating " + (errors.password ? "" : "mb-3")}
              >
                <input
                  type="password"
                  id="password"
                  placeholder="password"
                  className={
                    "form-control " + (errors.password ? "is-invalid" : "")
                  }
                  {...register("password")}
                />
                <label htmlFor="password">Password:</label>
              </div>
              {errors.password?.message && (
                <div className="row align-items-start text-start mb-3">
                  <span className="span-errors" role="alert">
                    {errors.password.message}
                  </span>
                </div>
              )}
              <div className="p-3">
                <button
                  type="submit"
                  className="btn btn-primary btn-sm px-4 me-md-2 btn-login-info"
                >
                  Delete Account
                </button>
              </div>
              {error && (
                <div className="alert alert-danger" role="alert">
                  {message}
                </div>
              )}
              {result && (
                <div className="alert alert-success" role="alert">
                  {result}
                </div>
              )}
            </form>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
